query User($id: ID!) {
  user(id: $id) {
    id
    email
    firstName
    lastName
    displayName
    avatar {
      id
      url(format: SMALL)
    }
    agreeToMarketingNewsletters
    registrationUtm {
      source
      medium
      campaign
      content
      term
      link {
        id
        title
        deleted
      }
      email {
        kind
        automationId
        automationName
        nodeId
        template
      }
      capturedAt
      backfilled
    }
    lastUtm {
      source
      medium
      campaign
      content
      term
      link {
        id
        title
        deleted
      }
      email {
        kind
        automationId
        automationName
        nodeId
        template
      }
      capturedAt
      backfilled
    }
    marketingConsent {
      at
    }
    language
    country
    timeZone
    createdAt
    updatedAt
  }
}
